import { CommandRegistry } from '@theia/core';
import { FrontendApplicationContribution, KeybindingRegistry } from '@theia/core/lib/browser';
import { ElectronMainMenuFactory } from '@theia/core/lib/electron-browser/menu/electron-main-menu-factory';
import { ElectronCommands } from '@theia/core/lib/electron-browser/menu/electron-menu-contribution';
import { inject, injectable, optional } from '@theia/core/shared/inversify';
import { isDevToolsEnabled } from '@theia-lved-core/common/build-env';

@injectable()
export class DevToolsContribution implements FrontendApplicationContribution {
    @inject(CommandRegistry)
    protected readonly commands!: CommandRegistry;

    @inject(KeybindingRegistry)
    protected readonly keybindings!: KeybindingRegistry;

    @inject(ElectronMainMenuFactory)
    @optional()
    protected readonly menuFactory?: ElectronMainMenuFactory;

    onStart(): void {
        if (isDevToolsEnabled()) return;

        this.commands.unregisterCommand(ElectronCommands.TOGGLE_DEVELOPER_TOOLS.id);
        this.commands.registerCommand(ElectronCommands.TOGGLE_DEVELOPER_TOOLS, {
            execute: () => undefined,
            isEnabled: () => false,
            isVisible: () => false
        });

        this.keybindings.registerKeybinding({
            command: `-${ElectronCommands.TOGGLE_DEVELOPER_TOOLS.id}`,
            keybinding: 'alt+f12'
        });

        this.menuFactory?.setMenuBar();
    }
}
